import { Component, OnInit, ElementRef, VERSION, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { AuthService } from '../../shared/services/auth.service';
import { ToastrService } from "ngx-toastr";
import { NavService } from "../../shared/services/nav.service";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

type UserFields = "email" | "password";
type FormErrors = { [u in UserFields]: string };

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  @ViewChild('container') container!: ElementRef;

  public show: boolean = false;
  public loginForm!: FormGroup;
  public registerForm!: FormGroup;
  public errorMessage: any;
  public isFormSubmitted!: boolean;
  role: any;

  constructor(private authService: AuthService, private fb: FormBuilder, private sanitizer: DomSanitizer, public router: Router, private el: ElementRef, private toastr: ToastrService, private navService: NavService) {
  }

  ngOnInit() {
    this.intializeLoginForm();
    localStorage.clear();
  }
  saveRole() {
    this.role = localStorage.getItem('role');
  }
  //intialize Login Form
  intializeLoginForm() {
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    })
  }

  showPassword() {
    this.show = !this.show;
  }

  // Simple Login
  login() {
    this.isFormSubmitted = true;
    const data = {};
    if (this.loginForm.valid) {
      data['username'] = this.loginForm.controls['email'].value;
      data['password'] = this.loginForm.controls['password'].value;
      this.router.navigate(["/dashboard/default"]);
      this.authService.login(data).subscribe(res => {
        if (res.status) {
          this.toastr.success("Successfully Authenticated!");
          localStorage.setItem('Authorization-Token', res.accessToken);
          localStorage.setItem('Refresh-Token', res.refreshToken);
          localStorage.setItem('role', res.scope);
          localStorage.setItem('email', res.userData.email);
          localStorage.setItem('userId', res.userData.id);
          localStorage.setItem('questionnarieQusId', (res.userData.questionari_id != undefined) ? res.userData.questionari_id : "");
          localStorage.setItem('institutionID', res?.userData?.institution_id);
          localStorage.setItem('institutionName', res?.userData?.institution_name);
          localStorage.setItem('mentorName', res?.userData?.name);
          localStorage.setItem('demo', res.userData.isDemoKey ? res.userData.isDemoKey : "");
          let user = {
            email: res.userData.email,
            password: res.userData.password,
            name: res.userData.name,
          };
          localStorage.setItem("user", JSON.stringify(user));
          this.navService.rebuildMenus();
          this.navigateBasedOnRole(res);
        }
        else {
          this.toastr.error(res?.message || 'Invalid credentials');
        }
      })
    }
  }

  //Navigate login Based On Role
  navigateBasedOnRole(LoginData: any) {
    if (LoginData.scope == "PORTAL_ADMIN") {
      this.router.navigate(["/admin/institute"]);
    }
    if (LoginData.scope == "PORTAL_INSTITUTION") {
      this.router.navigate(["/institute/institute-profile"]);
    }
    if (LoginData.scope == "PORTAL_SPOC") {
      this.router.navigate(["/spoc/spoc-institute"]);
    }
    if (LoginData.scope == "PORTAL_MENTOR") {
      this.router.navigate(["/mentor/mentor-details"]);
    }
  }

  demoVideo() {
    this.router.navigate(["/auth/demoVideo"]);
  }

}
